import { render, staticRenderFns } from "./inquiry.vue?vue&type=template&id=297842a0&scoped=true"
import script from "./inquiry.vue?vue&type=script&lang=js"
export * from "./inquiry.vue?vue&type=script&lang=js"
import style0 from "./inquiry.vue?vue&type=style&index=0&id=297842a0&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297842a0",
  null
  
)

export default component.exports